module.exports = __webpack_public_path__ + "66c31dcf4ad29d1cf0b6edf4b3f5c4f0.ttf";